import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=b7cb13fa&scoped=true&"
import script from "./banner.js?vue&type=script&lang=js&"
export * from "./banner.js?vue&type=script&lang=js&"
import style0 from "./banner.scss?vue&type=style&index=0&id=b7cb13fa&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cb13fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7cb13fa')) {
      api.createRecord('b7cb13fa', component.options)
    } else {
      api.reload('b7cb13fa', component.options)
    }
    module.hot.accept("./banner.vue?vue&type=template&id=b7cb13fa&scoped=true&", function () {
      api.rerender('b7cb13fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/snxguarantee/index/component/banner/banner.vue"
export default component.exports